import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputComponent } from "@components/input/input.component";
import { MultiSelectorComponent } from "@components/multi-selector/multi-selector.component";
import { Observable, of } from "rxjs";
import { SelectorComponent } from "~app/common/components/selector/selector.component";
import { ErsattningsgrundandeMatning, Mattslag } from "~app/common/models/constants";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ArbetsorderSearchFilterComponent } from "../../components/arbetsorder-search-filter/arbetsorder-search-filter.component";
import { ArbetsorderSearchBasePanel } from "../../models/arbetsorder-search-base-panel";

@Component({
    selector: "rask-arbetsorder-search-matning",
    templateUrl: "./arbetsorder-search-matning.component.html",
    styleUrls: ["./arbetsorder-search-matning.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ArbetsorderSearchFilterComponent,
        InputComponent,
        FormsModule,
        MultiSelectorComponent,
        SelectorComponent
    ]
})
export class ArbetsorderSearchMatningComponent extends ArbetsorderSearchBasePanel implements OnInit {

    mattslag: Observable<any[]>;

    ersattningTyper: Observable<string[]> = of(ErsattningsgrundandeMatning.alla);

    constructor() {
        super();
    }

    get skordarmatning() {
        const skordarmatning = this.searchFilter.virkesorder.skordarmatning;
        if (!ObjectUtils.hasValue(skordarmatning)) {
            return undefined;
        }

        return skordarmatning ? ErsattningsgrundandeMatning.Skordarmatning : ErsattningsgrundandeMatning.Industrimatning;
    }

    set skordarmatning(esm: string) {
        this.searchFilter.virkesorder.skordarmatning = !ObjectUtils.stringHasValue(esm) ? undefined : esm === ErsattningsgrundandeMatning.Skordarmatning;
    }

    ngOnInit(): void {
        this.setMattslag();
    }

    isDirty(): boolean {
        return this.searchFilter.virkesorder?.avtalatMattslag?.length > 0
            || ObjectUtils.stringHasValue(this.searchFilter.virkesorder?.mottagare)
            || ObjectUtils.hasValue(this.searchFilter.virkesorder?.skordarmatning)
            || ObjectUtils.stringHasValue(this.searchFilter.virkesorder?.redovisningshanvisning);
    }

    forceUpdateFilterChange(): void {
        // Krav från abstrakt klass
    }

    onChangeString(event: string, type: string) {
        if (typeof(event) !== "string") {
            return;
        }

        this.searchFilter.virkesorder[type] = event;
    }

    onChangeMattslag(event: string[]) {
        this.searchFilter.virkesorder.avtalatMattslag = event;
    }

    private setMattslag() {
        this.mattslag = of([
            { namn: Mattslag.M3MIUB },
            { namn: Mattslag.M3TOUB },
            { namn: Mattslag.M3TO },
            { namn: Mattslag.M3FUB },
            { namn: Mattslag.M3F },
            { namn: Mattslag.M3S },
            { namn: Mattslag.TON },
            { namn: Mattslag.ST },
            { namn: Mattslag.TTV },
            { namn: Mattslag.M3 },
            { namn: Mattslag.MWH }
        ]);
    }
}
